export const fetchingState = {
  FETCHING: 'fetching',
  LOADED: 'loaded',
  ERROR: 'error'
};

export const defaultPageSize = 50;

export const CHART_TYPES = {
  LINE: 'line',
  COLUMN: 'column'
};

export const userTypes = {
  PRIVATE: 'private',
  INTERNAL: 'internal',
  PUBLIC: 'public'
};

export const captchaKey = '6Ld23i8sAAAAAD_PWkJixQY4S88O_P43lIpfA1cq';

export const credentials = {
  local: {
    urls: {
      api: 'https://dev-container.trueprodigyapi.com',
      office: 'True Prodigy'
    }
  },
  dev: {
    urls: {
      api: 'https://dev-container.trueprodigyapi.com',
      office: 'True Prodigy'
    }
  },
  stage: {
    urls: {
      api: 'https://stage-container.trueprodigyapi.com',
      office: 'True Prodigy'
    }
  },
  prod: {
    urls: {
      api: 'https://prod-container.trueprodigyapi.com',
      office: 'Travis'
    }
  }
};
